import { createRouter, createWebHistory } from 'vue-router'
import Message from '@views/Message'
import sharedRoutes from './routes'

const routes = [
  ...sharedRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: Message,
    props: {
      title: 'Página não encontrada',
      text: 'Acesse o link enviado para seu e-mail.',
      character: 'cactus'
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
